import { DocketTemplate } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export type OnAfterSubmitFn = (
  docketTemplate: DocketTemplate
) => void | Promise<void>;

export type ManageDocketTemplateScreenContextType = {
  onAfterSubmit?: OnAfterSubmitFn;
};

export const ManageDocketTemplateScreenContext = React.createContext<
  ManageDocketTemplateScreenContextType | undefined
>(undefined);
